import "../src/dist/styles.css";
import About from "./Pages/About";
import Home from "./Pages/Home";
import Navbar from "../src/components/Navbar";
import { Route, Routes } from "react-router-dom";
import Models from "./Pages/Models";
import TestimonialsPage from "./Pages/TestimonialsPage";
import Contact from "./Pages/Contact";
import NotFoundPage from "./Pages/Errorpage";
import Airport from "./Pages/Airport";
import Tours from "./Pages/Tours";

//Hello

function App() {
  return (
    <>
      <Navbar />
      {/* Use an absolute path for the Routes component */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/airport-transfers" element={<Airport />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/models" element={<Models />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;